import { render, staticRenderFns } from "./MenuAdvertise.vue?vue&type=template&id=9836d110&scoped=true"
var script = {}
import style0 from "./MenuAdvertise.vue?vue&type=style&index=0&id=9836d110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9836d110",
  null
  
)

export default component.exports